export const ArrowIcon = (props) => (
  <svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.70078 18.7001L0.300781 17.3L8.50078 9.10005L0.300781 1.80005L1.60078 0.300049L11.4008 9.00005L1.70078 18.7001Z"
      fill={props.fillColor}
    />
  </svg>
);
